import { useContext } from "react";
import { useQuery } from "react-query";

import { UserContext } from "@/components/User";

import { fetchTimeReport } from "../service";
import { buildTimeReportQueryKey } from "./buildTimeReportQueryKey";

export const useTimeReportQuery = (guid: string) => {
  const { contextCompany, contextConsultantProfileId } = useContext(UserContext);

  const queryKey = buildTimeReportQueryKey(contextConsultantProfileId, guid);

  const query = useQuery(queryKey, () => fetchTimeReport({ companyId: contextCompany?.id, timeReportGuid: guid }));

  return {
    data: query.data!,
    refetch: query.refetch,
    isFetching: query.isFetching,
  };
};
